module.exports = __webpack_public_path__ + "img/Moment.93db8c47.jpg";